"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = void 0;
function evaluate(conditions) {
    return conditions.length !== 0 &&
        conditions.some(condition => condition.length !== 0 &&
            condition.every(predicate => {
                if (typeof predicate === 'function') {
                    return predicate();
                }
                else if (typeof predicate === 'boolean') {
                    return predicate;
                }
                else {
                    throw new Error('Invalid condition');
                }
            }));
}
exports.evaluate = evaluate;
